import React, {useEffect, useState} from "react";
import { Dialog, DialogContent } from "@mui/material";
import GenericDataGrid from "Admin/components/AdminComponents/GenericDataGrid";
import UpdateClientes from "./UpdateClientes";

function ListClientes() {
  const [pointer, setPointer] = useState(null)
  const [open, setOpen] = useState(false)

  const handleOpen = (id) =>{
    setPointer(id)
    setOpen(true);
  }
  
  const fields = [
    { name: 'id', label: 'ID' },
    { name: 'nome', label: 'Nome' },
    { name: 'email', label: 'E-mail' },
    { name: 'contato_telefone_1', label: 'Telefone' },
    { 
      name: 'status', 
      label: 'Status',
      render: (item) => item.status ? 'Ativo' : 'Inativo'
    }
  ];

  const actions = [
    { label: 'Editar', handler: (item) => handleOpen(item.id) }
  ];

  return (
    <>
      <GenericDataGrid
        title="Listagem de Clientes"
        endpoint="/clientes"
        fields={fields}
        actions={actions}
        selectable={true}
      />
      <Dialog 
       open={open && pointer} 
       onClose={() => setOpen(false)} 
       PaperProps={{
        style: {
          width: '70vw',
          height: '80vh',
          maxWidth: 'none', 
          maxHeight: 'none',
          }
        }}
        >
        <DialogContent>
          <UpdateClientes id={pointer} />
        </DialogContent>
      </Dialog>
    </>

  );
}

export default ListClientes;